import React from 'react';
import Icon from '../../../components/AppIcon';

const StatusTimeline = ({ timeline }) => {
  const getStatusIcon = (status) => {
    const icons = {
      'Created': 'FilePlus',
      'Approved': 'CheckCircle2',
      'Active': 'Play',
      'Extended': 'Clock',
      'Completed': 'CheckCheck',
      'Closed': 'XCircle'
    };
    return icons?.[status] || 'Circle';
  };

  const getStatusColor = (status) => {
    const colors = {
      'Created': 'bg-muted',
      'Approved': 'bg-success',
      'Active': 'bg-primary',
      'Extended': 'bg-accent',
      'Completed': 'bg-success',
      'Closed': 'bg-muted'
    };
    return colors?.[status] || 'bg-muted';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="GitBranch" size={20} color="var(--color-primary)" />
        <h2 className="text-lg font-semibold text-foreground">Status Timeline</h2>
      </div>
      <div className="relative">
        <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-border"></div>
        
        <div className="space-y-6">
          {timeline?.map((event, index) => (
            <div key={event?.id} className="relative flex gap-4">
              <div className={`relative z-10 w-12 h-12 rounded-full ${getStatusColor(event?.status)} flex items-center justify-center flex-shrink-0`}>
                <Icon name={getStatusIcon(event?.status)} size={20} color="white" />
              </div>
              
              <div className="flex-1 pt-1">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-medium text-foreground">{event?.status}</h3>
                  <span className="text-xs text-muted-foreground">{event?.timestamp}</span>
                </div>
                <p className="text-sm text-muted-foreground mb-2">{event?.description}</p>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Icon name="User" size={12} />
                  <span>{event?.performedBy}</span>
                  {event?.role && (
                    <>
                      <span>•</span>
                      <span>{event?.role}</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatusTimeline;